<template>
  <div class="layout-container">
    <v-sidebar></v-sidebar>
    <div class="main-container">
      <v-head></v-head>
      <router-view class="router-view"></router-view>
    
    </div>
  </div>
</template>

<script>
import vHead from './head'
import vSidebar from './sidebar'

export default {
  name: 'layout',
  components: {
    vHead,
    vSidebar
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/public/layout.vue